import { z } from 'zod';
export const AuthGuestRequest = z.object({
    device_id: z.string().min(8),
});
export const AuthSession = z.object({
    user_id: z.string(),
    display_name: z.string(),
    avatar_url: z.string().nullable(),
    access_token: z.string(),
    refresh_token: z.string(),
    expires_at: z.string(), // ISO
});
//# sourceMappingURL=auth.js.map